import React from 'react'
import { arrayOf, string } from 'prop-types'

import SectionContainer from 'components/atoms/SectionContainer'
import Container from 'components/atoms/Container'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'
import StairsSvg from 'components/atoms/SVGIcons/Stairs'
import Markdown from 'components/atoms/MarkdownContent'

import SectionTitleWithIcon from 'components/molecules/SectionTitleWithIcon'
import NumberedListItem from 'components/molecules/NumberedListItem'

const CareerStages = ({ title, subtitle, details }) => (
  <div id="career-stages" className="career-stages">
    <SectionContainer
      marginTop={80}
      marginBottom={120}
    >
      <Container>
        <Row>
          <Col md="3">
            <SectionTitleWithIcon
              icon={props => <StairsSvg fill="#0FC3C4" height="32px" width="32px" {...props}/>}
              title={title}
              stacked
            />
          </Col>
          <Col md="9">
            <Markdown className="career-stages__subtitle" content={subtitle} />
            <div className="career-stages__detail">
              {
                details && details.map((detail, idx) => (
                  <NumberedListItem
                    className="career-stages__detail-item"
                    key={`career-stages-${idx}`}
                    no={idx + 1}
                    content={detail}
                    bordered={false}
                  />
                ))
              }
            </div>
          </Col>
        </Row>
      </Container>
    </SectionContainer>
    <style jsx>
      {`
        .career-stages {
          &__detail {
            margin-top: 32px;
          }
          :global(.number-list-item) {
            margin-left: 24px;
          }
          :global(.section-title) {
            display: unset;
            &__icon {
              margin-bottom: 8px;
            }
          }
        }
      `}
    </style>
  </div>
)

CareerStages.propTypes = {
  title: string,
  subtitle: string,
  details: arrayOf(string),
}

export default CareerStages
